export class DeleteClientProfileReqData {
    name: string;

    constructor(name: string) {
        this.name = name;
    }
}
